import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginComponent } from '../login/login.component';

@Component({
  selector: 'app-user-confirmed',
  templateUrl: './user-confirmed.component.html',
  styleUrls: ['./user-confirmed.component.scss']
})
export class UserConfirmedComponent implements OnInit {
  @Input() message: any;

  constructor(
    private activeModal: NgbActiveModal,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
  }

  closeDialog() {
    this.activeModal.close();
  }
  openLoginModal() {
    this.closeDialog();
    // this.modalService.open(LoginComponent, { size: 'lg', centered: true });
  }
}
